import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import openModal from 'App/services/Modal';
import AppService from 'App/legacy/AppService';
import type { CampaignSelection } from './campaignSelection';

export default function updateContacts(
	rb: RequestBuilder,
	clientContacts: boolean = false,
	entity: string,
	extraParams: object | undefined,
	multiSelect: MultiSelect,
	campaignSelection?: CampaignSelection
) {
	const opts = {
		customerId: AppService.getCustomerId(),
		filters: rb,
		extraParams,
		clientContacts,
		entity,
		multiSelect,
		campaignSelection
	};
	return openModal('MultiUpdateContact', opts);
}
